import React from 'react'
import ReactDOM from 'react-dom';

import {
    takeEvery,
    put,
    select,
    takeLeading,
    takeLatest,
} from 'redux-saga/effects';
import * as actions from '../actions/index';
import * as actionTypes from '../actions/actionTypes';

//Components
import Notification from '../../components/Notifications/Notifications';

//Utils
import qs from 'qs';
import axios from '../../services/axios-client';

export function* getBundlesAll() {
    try {
        const companyKey = yield select(state => state.auth.companyKey);
        const userToken = yield select(state => state.auth.userToken);
        const shopID = yield select(state => state.companies.shopId);

        const data = {
            'shop_id': shopID
        };
        const response = yield axios.request({
            data: qs.stringify(data),
            method: 'post',
            url: '/api/bundle/list',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken,
            },
        });
        yield put(actions.getBundlesAllSucceeded(response.data.result));
    } catch (error) {
        yield put(actions.getBundlesAllFail());
        if(error.response && error.response.data && error.response.data.code === 401) {
            yield put(actions.logout());
            return
        }
        ReactDOM.render(
            <Notification type='error' error={error}/>,
            document.getElementById('notification')
        );
    }
}

export function* getBundlePaymentOptions(action) {
    try {
        yield put(actions.getBundlePaymentOptionSucceeded(null));
        const companyKey = yield select(state => state.auth.companyKey);
        const userToken = yield select(state => state.auth.userToken);
        const { shopId } = yield select(state => state.companies);

        const data = {
            'bundle_id': action.bundleId,
            'shop_id': shopId,
        };
        const response = yield axios.request({
            data: qs.stringify(data),
            method: 'post',
            url: '/api/payment/bundle/options/get',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken,
            },
        });
        yield put(actions.getBundlePaymentOptionSucceeded(response.data.result));
    } catch (error) {
        if(error.response && error.response.data && error.response.data.code === 401) {
            yield put(actions.logout());
            return
        }
        ReactDOM.render(
            <Notification type='error' error={error}/>,
            document.getElementById('notification')
        );
    }
}

export function* buyBundle(action) {
    try {
        const {userToken, companyKey} = yield select(state => state.auth);
        const { shopId } = yield select(state => state.companies);
        if(!userToken || !companyKey) {
            return;
        }

        const resp = yield axios.request({
            method: 'POST',   
            url: '/api/payment/bundle/buy',
            data: qs.stringify({
                bundle_id: action.bundleId,
                payment_type: action.paymentType,
                ideal_bank_id: action.idealBankId,
                shop_id: shopId,
                from_widget: 1,
                client_bundle_id: action.clientBundleID
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken
            }
        });

        const id = resp.data.result.client_bundle_id;
        const url = resp.data.result.payment_url;

        yield put(actions.buyBundleSucceeded(url, id));
    } catch (err) {
        ReactDOM.render(
            <Notification type='error' error={err}/>,
            document.getElementById('notification')
        );
    }
}

export function* confirmBundlePayment(action) {
    const { payload } = action;
    const { paymentType, onlinePayment, history, url } = payload;

    try {
        const {userToken, companyKey} = yield select(state => state.auth);
        if(!userToken || !companyKey) {
            return;
        }

        const clientBundleID = yield select(state => state.bundles.clientBundleID);

        const res = yield axios.request({
            method: 'POST',
            url: '/api/payment/confirm/bundle',
            data: qs.stringify({
                client_bundle_id: clientBundleID
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken
            }
        });

        if (res.status === 200) {
            yield put(actions.confirmBundlePaymentSucceeded({ paymentType, onlinePayment }));
            yield put(actions.getProfile());
            history.push(url);
        }
    } catch (err) {
        ReactDOM.render(
            <Notification type='error' error={err}/>,
            document.getElementById('notification')
        );
    }
}

export function* cancelBundlePayment({id}) {
    try {
        const userToken = yield select(state => state.auth.userToken);
        const companyKey = yield select(state => state.auth.companyKey);

        yield axios.request({
            method: 'POST',
            url: '/api/payment/cancel/bundle',
            data: qs.stringify({
                client_bundle_id: id
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken
            }
        });
    } catch(error) {
        ReactDOM.render(
            <Notification type='error' error={error}/>,
            document.getElementById('notification')
        );
    }
}

export function* checkBundlePaymentStatus({id}) {
    try {
        const userToken = yield select(state => state.auth.userToken);
        const companyKey = yield select(state => state.auth.companyKey);

        yield axios.request({
            method: 'POST',
            url: '/api/payment/check-status/bundle',
            data: qs.stringify({
                client_bundle_id: id
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
                'user-access-token': userToken
            }
        });
    } catch (error) {
        ReactDOM.render(
            <Notification type='error' error={error}/>,
            document.getElementById('notification')
        );
    }
}

export const watchBundles = [
    takeLatest(actionTypes.GET_BUNDLES_ALL, getBundlesAll),
    takeEvery(actionTypes.GET_BUNDLE_PAYMENT_OPTIONS, getBundlePaymentOptions),
    takeLeading(actionTypes.BUY_BUNDLE, buyBundle),
    takeLeading(actionTypes.CONFIRM_BUNDLE_PAYMENT, confirmBundlePayment),
    takeEvery(actionTypes.CANCEL_BUNDLE_PAYMENT, cancelBundlePayment),
    takeEvery(actionTypes.CHECK_BUNDLE_PAYMENT_STATUS, checkBundlePaymentStatus)
];
